export enum PaymentMethod {
  FIAT_PAYOUT = 'FIAT_PAYOUT',
  FIAT_OTHER = 'FIAT_OTHER',
  CRYPTO_TRANSFER = 'CRYPTO_TRANSFER'
}
